import * as React from 'react';

const Download24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M21 15.75C21.4142 15.75 21.75 16.0858 21.75 16.5V19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V16.5C2.25 16.0858 2.58579 15.75 3 15.75C3.4142 15.75 3.75 16.0858 3.75 16.5V19C3.75 19.6904 4.30965 20.25 5 20.25H19C19.6903 20.25 20.25 19.6903 20.25 19V16.5C20.25 16.0858 20.5858 15.75 21 15.75ZM12 2.25C12.4142 2.25001 12.75 2.5858 12.75 3V15.2686L15.4873 12.7031C15.7895 12.4198 16.2636 12.4351 16.5469 12.7373C16.8302 13.0395 16.8149 13.5136 16.5127 13.7969L12.5127 17.5469C12.2242 17.8173 11.7758 17.8173 11.4873 17.5469L7.4873 13.7969C7.18512 13.5136 7.16983 13.0395 7.45312 12.7373C7.73642 12.4351 8.21051 12.4198 8.5127 12.7031L11.25 15.2686V3C11.25 2.58579 11.5858 2.25 12 2.25Z'
				fill='#333333'
			/>
		</svg>
	);
};

export default Download24;
